import EmployeesListComp from '../../Components/EmployeesReview/EmployeesListComp';

function EmployeesListPage() {
  return <EmployeesListComp />;
}

export default EmployeesListPage;
